import gsap from 'gsap';
import { useGSAP } from '@gsap/react';
import '../utils/i18n.ts';
import { RootProviders } from '../providers';
import { Routes } from './Routes.tsx';

gsap.registerPlugin(useGSAP);

const App = () => (
  <RootProviders>
    <Routes />
  </RootProviders>
);

export { App };
